import { Component } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { environment } from '@environments/environment';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'cp-mobile-app-version-not-compatible',
  imports: [ButtonModule],
  templateUrl: './mobile-app-version-not-compatible.component.html',
  styleUrl: './mobile-app-version-not-compatible.component.scss',
})
export class MobileAppVersionNotCompatibleComponent {
  gotToStore(): void {
    if (Capacitor.getPlatform() == 'ios') {
      window.open(environment.mobileApp?.iosStoreUrl, '_blank');
    }
    if (Capacitor.getPlatform() == 'android') {
      window.open(environment.mobileApp?.androidStoreUrl, '_blank');
    }
  }
}
